/**
 * جابه‌جاییِ صفحه‌کلید در جدول‌های ورودِ داده — مثلِ اکسل.
 *
 * چرا: در «ثبت کارکرد» کاربر ده‌ها سلول پر می‌کند. Tabِ پیش‌فرضِ مرورگر افقی
 * می‌رود (سلولِ بغلی)، ولی دفترِ کارخانه ستونی پر می‌شود: یک عملیات را برای
 * همهٔ ردیف‌ها می‌زنند و بعد می‌روند ستونِ بعد. پس Tab باید **پایین** برود.
 *
 * قواعد:
 *   Tab / Enter / ↓  → سلولِ پایین (همان ستون)
 *   Shift+Tab / ↑    → سلولِ بالا
 *   ← →              → ستونِ بغلی، ولی **فقط وقتی مکان‌نما لبهٔ متن است**؛
 *                      وگرنه داخلِ نوشته حرکت می‌کند و کاربر نمی‌تواند تایپش
 *                      را ویرایش کند.
 *
 * RTL: در جدولِ راست‌به‌چپ ستونِ بعدی سمتِ چپ است، پس ← جلو می‌رود.
 */

const FOCUSABLE = "input:not([disabled]):not([type=hidden]), textarea:not([disabled])";

/** آیا این عنصر یک Selectِ باز است؟ آن‌وقت Enter/فلش مالِ خودِ لیست است. */
function inOpenDropdown(el) {
  const combo = el.closest(".ant-select");
  return !!combo && combo.querySelector('[aria-expanded="true"]') != null;
}

/** مکان‌نما لبهٔ متن است؟ (برای Selectها که متنِ قابلِ ویرایش ندارند: بله) */
function caretAtEdge(el, forward) {
  if (el.tagName !== "INPUT" && el.tagName !== "TEXTAREA") return true;
  if (el.selectionStart == null) return true;
  const len = (el.value || "").length;
  if (el.selectionStart !== el.selectionEnd) return false;
  return forward ? el.selectionStart >= len : el.selectionStart <= 0;
}

/** جهتِ نوشتار — نزدیک‌ترین `dir` صریح، وگرنه استایلِ محاسبه‌شده.
 *  (فقط getComputedStyle کافی نیست: ارث‌بریِ dir را همه‌جا نمی‌دهد.) */
function isRtl(el) {
  const withDir = el.closest("[dir]");
  if (withDir) return withDir.getAttribute("dir") === "rtl";
  return getComputedStyle(el).direction === "rtl";
}

function cellsOfRow(tr) {
  return Array.from(tr.children);
}

function focusCell(td) {
  if (!td) return false;
  const el = td.querySelector(FOCUSABLE);
  if (!el) return false;
  el.focus();
  if (typeof el.select === "function") {
    // انتخابِ کاملِ محتوا: تایپِ بعدی جایگزین می‌شود، مثلِ اکسل
    try { el.select(); } catch { /* Selectها select ندارند */ }
  }
  return true;
}

/** از سلولِ فعلی به سمتِ دلخواه برو؛ سلول‌های بدونِ ورودی رد می‌شوند. */
function move(td, dRow, dCol) {
  const tr = td.closest("tr");
  const tbody = tr && tr.parentElement;
  if (!tbody) return false;
  const rows = Array.from(tbody.children).filter((r) => r.querySelector("td"));
  const rowIdx = rows.indexOf(tr);
  const colIdx = cellsOfRow(tr).indexOf(td);
  if (rowIdx < 0 || colIdx < 0) return false;

  if (dRow) {
    for (let i = rowIdx + dRow; i >= 0 && i < rows.length; i += dRow) {
      if (focusCell(cellsOfRow(rows[i])[colIdx])) return true;
    }
    return false;
  }
  const cells = cellsOfRow(tr);
  for (let i = colIdx + dCol; i >= 0 && i < cells.length; i += dCol) {
    if (focusCell(cells[i])) return true;
  }
  return false;
}

/**
 * هندلرِ آماده برای گذاشتن روی wrapperِ جدول:
 *   <div onKeyDown={gridKeyNav}>…<Table/>…</div>
 */
export default function gridKeyNav(e) {
  const el = e.target;
  if (!el || !el.closest) return;
  const td = el.closest("td");
  if (!td || !td.closest("table")) return;

  const rtl = isRtl(td);
  const key = e.key;

  // Selectِ باز: فلش‌ها و Enter مالِ خودِ لیستِ گزینه‌هاست
  const dropdownOpen = inOpenDropdown(el);

  if (key === "Tab") {
    // Tab عمداً پایین می‌رود، نه جلو — دفتر ستونی پر می‌شود
    if (move(td, e.shiftKey ? -1 : 1, 0)) e.preventDefault();
    return;
  }
  if (key === "Enter" && !dropdownOpen) {
    if (move(td, 1, 0)) e.preventDefault();
    return;
  }
  if (dropdownOpen) return;

  if (key === "ArrowDown") {
    if (move(td, 1, 0)) e.preventDefault();
    return;
  }
  if (key === "ArrowUp") {
    if (move(td, -1, 0)) e.preventDefault();
    return;
  }
  if (key === "ArrowLeft" || key === "ArrowRight") {
    // در RTL، «جلو» سمتِ چپ است
    const forward = rtl ? key === "ArrowLeft" : key === "ArrowRight";
    if (!caretAtEdge(el, forward)) return;      // هنوز داخلِ متن است
    if (move(td, 0, forward ? 1 : -1)) e.preventDefault();
  }
}
